import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import Column, { ColumnsRow } from 'bloko/blocks/column';
import BlokoLink from 'bloko/blocks/link';
import Text, { TextImportance, TextSize } from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import styles from './index.less';

const TrlKeys = {
    title: 'applicantServices.prepareResume.awaitingTitle',
    resumeAbout: 'applicantServices.prepareResume.resumeAbout',
    consultationAbout: 'applicantServices.prepareResume.consultationAbout',
};

const PrepareResume: TranslatedComponent = ({ trls }) => {
    const order = useSelectorNonNullable(({ careerServiceOrder }) => careerServiceOrder);
    const resumes = useSelectorNonNullable((state) => state.resumeIdentifiers);
    const selectedResume = resumes.filter((resume) => resume.hash === order.resumeHash)[0];

    return (
        <Column xs="4" s="6" m="9" l="11" container>
            <ColumnsRow>
                <Column xs="4" s="6" m="9" l="11">
                    <Text size={TextSize.ExtraLarge}>{trls[TrlKeys.title]}</Text>
                </Column>
            </ColumnsRow>
            <VSpacing base={6} />
            <div className={styles.separator} />
            <VSpacing base={6} />
            <ColumnsRow>
                <Column xs="4" s="6" m="3" l="4">
                    <Text importance={TextImportance.Tertiary}>{trls[TrlKeys.resumeAbout]}</Text>
                </Column>
                <Column xs="4" s="6" m="6" l="7">
                    {selectedResume && (
                        <Text>
                            <BlokoLink
                                Element={SPALink}
                                to={`/resume/${selectedResume.hash}`}
                                target="_blank"
                                disableVisited
                            >
                                {selectedResume.title}
                            </BlokoLink>
                        </Text>
                    )}
                </Column>
            </ColumnsRow>
            <VSpacing base={6} />
            <ColumnsRow>
                <Column xs="4" s="6" m="3" l="4">
                    <Text importance={TextImportance.Tertiary}>{trls[TrlKeys.consultationAbout]}</Text>
                </Column>
                <Column xs="4" s="6" m="6" l="7">
                    <Text>{order.description}</Text>
                </Column>
            </ColumnsRow>
        </Column>
    );
};

export default translation(PrepareResume);
